import { Component, inject, OnInit, signal, ViewChild } from '@angular/core';
import { CustomFilter, DynamicColumn, TableComponent } from '../../../../@shared/components/table-component/table-component';
import { Params } from '../../../../services/utilis/add-params-service';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, map, switchMap, tap } from 'rxjs';
import { PaginatorState } from 'primeng/paginator';
import { ActivatedRoute, Router } from '@angular/router';
import { EmployeeActivityService } from '../../../../services/employees/employee-activity-service';
import { EmployeeActivity } from '../../../../models/employee-activity';
import { enumToOptions } from '../../../../@shared/utility/enumToOptions';
import { ActionType, TargetType } from '../../../../models/enums';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-employee-activity-log-list',
  imports: [TableComponent, CommonModule],
  templateUrl: './employee-activity-log-list.html',
  styleUrl: './employee-activity-log-list.scss'
})
export class EmployeeActivityLogList implements OnInit {

  @ViewChild(TableComponent) table!: TableComponent<EmployeeActivity>;

  params = [
    "page",
    "size",
    "search",
    'sortBy',
    'sortDirection',
    'targetType',
    'actionType',
    'createdFrom',
    'createdTo',
  ]

  modifiedParams: Params = {
    page: "page",
    size: "size",
    search: "search",
    sortBy: "sortBy",
    sortDirection: "sortDirection",
    targetType: "targetType",
    actionType: "actionType",
    createdFrom: "createdFrom",
    createdTo: "createdTo",
  }

  walletPaymentOptions = [
    { label: 'Credit', value: ActionType.CREDIT },
    { label: 'Debit', value: ActionType.DEBIT }
  ];

  customerOptions = [
    { label: 'Group Member Add', value: ActionType.GROUP_MEMBER_ADD },
    { label: 'Group Member Remove', value: ActionType.GROUP_MEMBER_REMOVE },
    { label: 'Status Change', value: ActionType.STATUS_CHANGE }
  ];

  groupOptions = [
    { label: 'Group Creation', value: ActionType.CREATE },
    { label: 'Group Update', value: ActionType.UPDATE },
    { label: 'Group Deletion', value: ActionType.DELETE },
    { label: 'Group Member Add', value: ActionType.GROUP_MEMBER_ADD },
    { label: 'Group Member Remove', value: ActionType.GROUP_MEMBER_REMOVE },
    { label: 'Discount Change', value: ActionType.DISCOUNT_CHANGE }
  ];

  /** Columns definitions */

  customerTargetTypeColumns: DynamicColumn<EmployeeActivity>[] = [
    { header: 'ID', field: 'id', sortable: true },
    { header: 'Action Type', field: 'actionType', sortable: false, isCapitalize: true },
    { header: 'Customer name', field: 'targetName', sortable: false },
    { header: 'Customer number', field: 'targetNumber', sortable: false },
    { header: 'Old', field: 'oldValue', sortable: false, cellClass: "text-red-500", isCapitalize: true },
    { header: 'New', field: 'newValue', sortable: false, cellClass: "text-green-500", isCapitalize: true },
    { header: 'Employee ID', field: 'employeeId', sortable: false },
    { header: 'Employee email', field: 'employeeEmail', sortable: false },
    { header: 'Created At', field: 'createdAt', isDateTime: true, sortable: true },
  ];

  groupTargetTypeColumns: DynamicColumn<EmployeeActivity>[] = [
    { header: 'ID', field: 'id', sortable: true },
    { header: 'Action Type', field: 'actionType', sortable: false, isCapitalize: true },
    { header: 'Group name', field: 'targetName', sortable: false },
    { header: 'Group number', field: 'targetNumber', sortable: false },
    { header: 'Old', field: 'oldValue', sortable: false, cellClass: "text-red-500", isCapitalize: true },
    { header: 'New', field: 'newValue', sortable: false, cellClass: "text-green-500", isCapitalize: true },
    { header: 'Employee ID', field: 'employeeId', sortable: false },
    { header: 'Employee email', field: 'employeeEmail', sortable: false },
    { header: 'Created At', field: 'createdAt', isDateTime: true, sortable: true },
  ];

  carTargetTypeColumns: DynamicColumn<EmployeeActivity>[] = [
    { header: 'ID', field: 'id', sortable: true },
    { header: 'Action Type', field: 'actionType', sortable: false, isCapitalize: true },
    { header: 'Car name', field: 'targetName', sortable: false },
    { header: 'Car number', field: 'targetNumber', sortable: false },
    { header: 'Old status', field: 'oldValue', sortable: false, cellClass: "text-red-500", isCapitalize: true },
    { header: 'New status', field: 'newValue', sortable: false, cellClass: "text-green-500", isCapitalize: true },
    { header: 'Employee ID', field: 'employeeId', sortable: false },
    { header: 'Employee email', field: 'employeeEmail', sortable: false },
    { header: 'Created At', field: 'createdAt', isDateTime: true, sortable: true },
  ];

  walletTargetTypeColumns: DynamicColumn<EmployeeActivity>[] = [
    { header: 'ID', field: 'id', sortable: true },
    { header: 'Action Type', field: 'actionType', sortable: false, isCapitalize: true },
    { header: 'Customer name', field: 'targetName', sortable: false },
    { header: 'Customer number', field: 'targetNumber', sortable: false },
    { header: 'Old amount', field: 'oldValue', sortable: false, cellClass: "text-red-500", isCapitalize: true },
    { header: 'New amount', field: 'newValue', sortable: false, cellClass: "text-green-500", isCapitalize: true },
    { header: 'Employee ID', field: 'employeeId', sortable: false },
    { header: 'Employee email', field: 'employeeEmail', sortable: false },
    { header: 'Created At', field: 'createdAt', isDateTime: true, sortable: true },
  ];

  paymentCardTargetTypeColumns: DynamicColumn<EmployeeActivity>[] = [
    { header: 'ID', field: 'id', sortable: true },
    { header: 'Action Type', field: 'actionType', sortable: false, isCapitalize: true },
    { header: 'Customer name', field: 'targetName', sortable: false },
    { header: 'Customer number', field: 'targetNumber', sortable: false },
    { header: 'Old amount', field: 'oldValue', sortable: false, cellClass: "text-red-500", isCapitalize: true },
    { header: 'New amount', field: 'newValue', sortable: false, cellClass: "text-green-500", isCapitalize: true },
    { header: 'Employee ID', field: 'employeeId', sortable: false },
    { header: 'Employee email', field: 'employeeEmail', sortable: false },
    { header: 'Created At', field: 'createdAt', isDateTime: true, sortable: true },
  ];

  tableColumns: DynamicColumn<EmployeeActivity>[] = [...this.carTargetTypeColumns];

  employeeActivitiesList = signal<EmployeeActivity[]>([]);
  totalRecords = signal(0);

  first = 0;
  rows = 20;

  searchControl = new FormControl('');

  createdDateFilter: CustomFilter = {
    key: "created",
    label: "Date",
    type: "date-range",
    options: []
  }

  targetTypeFilter: CustomFilter = {
    key: "targetType",
    label: "Target type",
    type: "select",
    options: enumToOptions(TargetType),
    clearable: false
  }

  private previousTargetType?: string;

  private employeeActivityService = inject(EmployeeActivityService);
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);

  ngOnInit() {
    this.getEmployeesList();
    this.setDefaultTargetType();
    this.listenToQueryParams();
  }

  /** API call */
  getEmployeesList = () => {

    this.activatedRoute.queryParams.pipe(

      map((params) =>
        Object.fromEntries(
          Object.entries(params)
            .filter(([key]) => this.params.includes(key))
            .map(([key, value]) => [this.modifiedParams[key] || key, value])
        )
      ),

      distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)),

      tap((queryParams) => {
        this.searchControl.setValue(queryParams['search'], { emitEvent: false });
        this.rows = queryParams['size'] ? +queryParams['size'] : 20;
      }),

      switchMap((queryParams) => {

        const params = {
          ...queryParams,
          sortBy: queryParams['sortBy'] ?? 'createdAt',
          sortDirection: queryParams['sortDirection'] ?? 'DESC',
        };

        return this.employeeActivityService.getEmployeeActivityList(params);
      })

    ).subscribe(res => {

      this.employeeActivitiesList.set(res.data.content);
      this.totalRecords.set(res.data.totalElements);

      this.first = ((res.data.currentPage + 1) * res.data.pageSize) - res.data.pageSize;

    });
  }

  /** Pagination */
  onPageChange = (event: PaginatorState) => {

    this.router.navigate([], {
      queryParams: {
        page: event.page,
        size: event.rows
      },
      queryParamsHandling: 'merge'
    });

  }

  /** Search */
  onSearchChange = () => {

    this.searchControl.valueChanges.pipe(
      debounceTime(200),
      distinctUntilChanged()
    ).subscribe(value => {

      this.router.navigate([], {
        queryParams: {
          search: value || '',
          page: undefined,
          size: undefined
        },
        queryParamsHandling: "merge"
      });

    });

  }

  /** Change columns depending on targetType */
  onTypeChange = (type: string) => {

    // 1️⃣ Update table columns depending on targetType
    if (type === TargetType.CAR) {
      this.tableColumns = [...this.carTargetTypeColumns];
    } else if (type === TargetType.CUSTOMER) {
      this.tableColumns = this.customerTargetTypeColumns.map(col =>
        col.field === 'actionType'
          ? { ...col, isFilterable: true, filterType: 'select', filterOptions: this.customerOptions }
          : col
      );
    } else if (type === TargetType.CUSTOMER_GROUP) {
      this.tableColumns = this.groupTargetTypeColumns.map(col =>
        col.field === 'actionType'
          ? { ...col, isFilterable: true, filterType: 'select', filterOptions: this.groupOptions }
          : col
      );
    } else if (type === TargetType.WALLET) {
      this.tableColumns = this.walletTargetTypeColumns.map(col =>
        col.field === 'actionType'
          ? {
            ...col,
            isFilterable: true,
            filterType: 'select',
            filterOptions: this.walletPaymentOptions
          }
          : col
      );
    } else if (type === TargetType.PAYMENT_CARD) {
      this.tableColumns = this.paymentCardTargetTypeColumns.map(col =>
        col.field === 'actionType'
          ? {
            ...col,
            isFilterable: true,
            filterType: 'select',
            filterOptions: this.walletPaymentOptions
          }
          : col
      );
    }

    // 2️⃣ Re-initialize only missing filters
    this.table.columns = this.tableColumns;
    this.table.initializeFiltersForMissingColumns();

    this.searchControl.setValue('', { emitEvent: false });
    this.first = 0;
    this.rows = 20;

  };

  exporting = signal(false);

  exportActivity = () => {
    const params = Object.fromEntries(
      Object.entries(this.activatedRoute.snapshot.queryParams)
        .filter(([key]) => this.params.includes(key))
        .map(([key, value]) => [this.modifiedParams[key] || key, value])
    );
    this.exporting.set(true);
    this.employeeActivityService.exportEmployeeActivity(params).subscribe({
      next: (blob) => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `employee-activity-${Date.now()}.xlsx`;
        a.click();
        URL.revokeObjectURL(url);
        this.exporting.set(false);
      },
      error: () => this.exporting.set(false)
    });
  };

  /** Default targetType */
  setDefaultTargetType = () => {

    const snapshot = this.activatedRoute.snapshot.queryParamMap;

    if (!snapshot.has('targetType')) {

      this.router.navigate([], {
        queryParams: { targetType: TargetType.CAR },
        queryParamsHandling: 'merge',
        replaceUrl: true
      });

    }

  }

  /** Listen to URL params */
  private listenToQueryParams = () => {

    this.activatedRoute.queryParams.subscribe(params => {

      if (!params['targetType']) {

        this.router.navigate([], {
          queryParams: { ...params, targetType: TargetType.CAR },
          replaceUrl: true
        });

        return;
      }

      const targetType = params['targetType'];

      // Reset actionType when targetType changes (options differ per type)
      const targetTypeChanged = this.previousTargetType !== undefined && this.previousTargetType !== targetType;
      this.previousTargetType = targetType;

      if (targetTypeChanged && params['actionType']) {
        this.router.navigate([], {
          queryParams: { actionType: null },
          queryParamsHandling: 'merge',
          replaceUrl: true
        });

        return;
      }

      this.first = (+params['page'] || 0) * this.rows;

      this.onTypeChange(targetType);

    });

  }

}